module.exports = ".class-joined-success {\n  position: absolute;\n  top: 90px;\n}\n\n.pair-id {\n  color: red;\n  font-weight: bold;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/class-joined-success/class-joined-success.component.css
// module id = ./src/app/components/class-joined-success/class-joined-success.component.css
// module chunks = main